import React, { useState } from "react";
import {
  FaRobot,
  FaUsers,
  FaChartLine,
  FaHandshake,
  FaCloudUploadAlt,
  FaUserCheck,
} from "react-icons/fa";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const AboutUs = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const styles = {
    container: {
      fontFamily: "var(--font-family)",
      backgroundColor: "var(--background-color)",
      color: "var(--subheading-color)",
      overflow: "hidden",
    },
    hero: {
      background: "linear-gradient(135deg, #286a94 0%, #1a4d6d 100%)",
      padding: "0",
      position: "relative",
      overflow: "hidden",
      minHeight: "700px",
      display: "flex",
      alignItems: "center",
    },
    heroOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "radial-gradient(circle at 80% 20%, rgba(255,255,255,0.15) 0%, transparent 50%), radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)",
    },
    heroPattern: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      opacity: 0.4,
    },
    heroContent: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "30px 20px",
      position: "relative",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      gap: "60px",
      flexWrap: "wrap",
    },
    heroLeft: {
      flex: "1",
      minWidth: "300px",
    },
    heroRight: {
      flex: "1",
      minWidth: "300px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    heroIllustration: {
      width: "100%",
      maxWidth: "450px",
      height: "400px",
      background: "rgba(255,255,255,0.1)",
      borderRadius: "30px",
      backdropFilter: "blur(10px)",
      border: "2px solid rgba(255,255,255,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: "30px",
      padding: "40px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    },
    heroIconGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "20px",
      width: "100%",
    },
    heroIconBox: {
      background: "rgba(255,255,255,0.15)",
      borderRadius: "20px",
      padding: "25px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(5px)",
      border: "1px solid rgba(255,255,255,0.2)",
      transition: "all 0.3s ease",
    },
    heroHeading: {
      fontSize: "58px",
      fontWeight: "800",
      color: "#ffffff",
      marginBottom: "24px",
      lineHeight: "1.2",
      textShadow: "0 4px 30px rgba(0,0,0,0.3)",
    },
    heroSubheading: {
      fontSize: "24px",
      fontWeight: "600",
      color: "rgba(255,255,255,0.9)",
      marginBottom: "20px",
      textShadow: "0 2px 10px rgba(0,0,0,0.2)",
    },
    heroText: {
      fontSize: "18px",
      lineHeight: "1.8",
      color: "rgba(255,255,255,0.9)",
      marginBottom: "30px",
      textShadow: "0 1px 5px rgba(0,0,0,0.1)",
    },
    heroStats: {
      display: "flex",
      gap: "40px",
      marginTop: "20px",
      flexWrap: "wrap",
    },
    heroStat: {
      textAlign: "left",
    },
    heroStatNumber: {
      fontSize: "36px",
      fontWeight: "800",
      color: "#ffffff",
      display: "block",
      textShadow: "0 2px 10px rgba(0,0,0,0.2)",
    },
    heroStatLabel: {
      fontSize: "14px",
      color: "rgba(255,255,255,0.8)",
      display: "block",
      marginTop: "5px",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    section: {
      padding: "40px 10px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    sectionTitle: {
      fontSize: "42px",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "60px",
      color: "#286a94",
    },
    cardsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "30px",
      marginTop: "40px",
    },
    card: {
      backgroundColor: "#ffffff",
      padding: "40px 30px",
      borderRadius: "20px",
      boxShadow:
        hoveredCard !== null
          ? "0 10px 40px rgba(0,0,0,0.08)"
          : "0 4px 20px rgba(0,0,0,0.06)",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: "1px solid rgba(0,0,0,0.05)",
      position: "relative",
      overflow: "hidden",
    },
    cardHovered: {
      transform: "translateY(-12px)",
      boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
      borderColor: "rgba(0,0,0,0.1)",
    },
    cardGlow: {
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background:
        "radial-gradient(circle, rgba(0,0,0,0.03) 0%, transparent 70%)",
      opacity: 0,
      transition: "opacity 0.4s",
    },
    iconWrapper: {
      width: "80px",
      height: "80px",
      borderRadius: "20px",
      background: "#286a94",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "24px",
      transition: "transform 0.4s",
    },
    icon: {
      fontSize: "36px",
      color: "#ffffff",
    },
    cardTitle: {
      fontSize: "22px",
      fontWeight: "700",
      marginBottom: "12px",
      color: "var(--heading-color)",
      textAlign: "center",
    },
    cardText: {
      fontSize: "16px",
      color: "var(--subheading-color)",
      textAlign: "center",
      lineHeight: "1.6",
    },
    featureSection: {
      display: "flex",
      alignItems: "center",
      gap: "60px",
      marginBottom: "100px",
    },
    featureSectionReverse: {
      flexDirection: "row-reverse",
    },
    featureImageWrapper: {
      flex: "1",
      minWidth: "300px",
      position: "relative",
    },
    featureImage: {
      width: "100%",
      height: "400px",
      objectFit: "cover",
      borderRadius: "24px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    },
    featureContent: {
      flex: "1",
      minWidth: "300px",
    },
    featureTitle: {
      fontSize: "36px",
      fontWeight: "700",
      marginBottom: "20px",
      color: "#286a94",
    },
    featureText: {
      fontSize: "18px",
      lineHeight: "1.8",
      color: "var(--subheading-color)",
    },
    missionSection: {
      background: "var(--background-color)",
      padding: "80px 40px",
      borderRadius: "30px",
      textAlign: "center",
      margin: "0 20px",
      border: "2px solid rgba(0,0,0,0.05)",
    },
    missionText: {
      fontSize: "20px",
      lineHeight: "1.8",
      color: "var(--subheading-color)",
      maxWidth: "900px",
      margin: "0 auto",
    },
  };

  const features = [
    {
      icon: FaRobot,
      title: "AI-Powered Screening",
      text: "Automatically screen candidates and highlight the best matches using intelligent AI algorithms.",
    },
    {
      icon: FaUsers,
      title: "Smart Candidate Matching",
      text: "Match candidates to roles based on deep learning analysis of skills, experience, and cultural fit.",
    },
    {
      icon: FaChartLine,
      title: "Data-Driven Insights",
      text: "Access powerful analytics to measure recruitment performance and optimize decision-making.",
    },
    {
      icon: FaHandshake,
      title: "Enhanced Collaboration",
      text: "Streamline communication and feedback between hiring managers, recruiters, and interviewers.",
    },
    {
      icon: FaCloudUploadAlt,
      title: "Automated Resume Parsing",
      text: "Quickly extract key information from resumes using AI-based parsing for faster shortlisting.",
    },
    {
      icon: FaUserCheck,
      title: "Skill Verification & Assessments",
      text: "Integrate AI-powered skill tests to validate candidate capabilities before final selection.",
    },
  ];

  return (
    <div style={styles.container}>
      <Navbar />

      {/* Hero Section */}
      <div style={styles.hero}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroPattern}></div>
        <div style={styles.heroContent}>
          <div style={styles.heroLeft}>
            <h1 style={styles.heroHeading} className="hero-heading">
              About eBench.ai
            </h1>
            <p style={styles.heroSubheading} className="hero-subheading">
              Revolutionizing Recruitment with AI
            </p>
            <p style={styles.heroText}>
              eBench.ai is an innovative AI-based hiring platform designed to
              simplify and enhance recruitment processes. We help companies
              identify top talent faster, reduce hiring bias, and make
              data-driven hiring decisions through cutting-edge artificial
              intelligence.
            </p>
            <div style={styles.heroStats} className="hero-stats">
              <div style={styles.heroStat}>
                <span style={styles.heroStatNumber}>50K+</span>
                <span style={styles.heroStatLabel}>Candidates Screened</span>
              </div>
              <div style={styles.heroStat}>
                <span style={styles.heroStatNumber}>500+</span>
                <span style={styles.heroStatLabel}>Companies Trust Us</span>
              </div>
              <div style={styles.heroStat}>
                <span style={styles.heroStatNumber}>89%</span>
                <span style={styles.heroStatLabel}>Success Rate</span>
              </div>
            </div>
          </div>
          <div style={styles.heroRight}>
            <div style={styles.heroIllustration}>
              <div style={styles.heroIconGrid}>
                <div style={styles.heroIconBox} className="hero-icon-box">
                  <FaRobot style={{ fontSize: "40px", color: "#fff" }} />
                </div>
                <div style={styles.heroIconBox} className="hero-icon-box">
                  <FaUsers style={{ fontSize: "40px", color: "#fff" }} />
                </div>
                <div style={styles.heroIconBox} className="hero-icon-box">
                  <FaChartLine style={{ fontSize: "40px", color: "#fff" }} />
                </div>
                <div style={styles.heroIconBox} className="hero-icon-box">
                  <FaHandshake style={{ fontSize: "40px", color: "#fff" }} />
                </div>
              </div>
              <div
                style={{
                  fontSize: "16px",
                  color: "rgba(255,255,255,0.9)",
                  textAlign: "center",
                  fontWeight: "600",
                  letterSpacing: "1px",
                }}
              >
                AI-POWERED HIRING PLATFORM
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mission & Vision */}
      <div style={styles.section}>
        <div style={styles.missionSection}>
          <h2 style={{ ...styles.sectionTitle, marginBottom: "30px" }}>
            Our Mission & Vision
          </h2>
          <p style={styles.missionText}>
            Our mission is to transform hiring through intelligent automation,
            creating a fairer, faster, and smarter recruitment experience. We
            envision a future where companies hire the right talent
            effortlessly, and candidates find opportunities that truly match
            their skills and aspirations. Together, we're building a world where
            every hiring decision is informed, unbiased, and leads to meaningful
            connections.
          </p>
        </div>
      </div>

      {/* Features Cards */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>Our Core Features</h2>
        <div style={styles.cardsContainer}>
          {features.map((feature, index) => {
            const Icon = feature.icon;
            const isHovered = hoveredCard === index;
            return (
              <div
                key={index}
                style={{
                  ...styles.card,
                  ...(isHovered ? styles.cardHovered : {}),
                }}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div
                  style={styles.cardGlow}
                  className={isHovered ? "glow-active" : ""}
                ></div>
                <div
                  style={{
                    ...styles.iconWrapper,
                    transform: isHovered
                      ? "scale(1.1) rotate(5deg)"
                      : "scale(1) rotate(0deg)",
                  }}
                >
                  <Icon style={styles.icon} />
                </div>
                <h3 style={styles.cardTitle}>{feature.title}</h3>
                <p style={styles.cardText}>{feature.text}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Feature Section 1 */}
      <div style={styles.section}>
        <div style={styles.featureSection}>
          <div style={styles.featureImageWrapper}>
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
              alt="Streamlined Recruitment"
              style={styles.featureImage}
            />
          </div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>Streamlined Recruitment Process</h3>
            <p style={styles.featureText}>
              From sourcing to onboarding, eBench.ai simplifies every step of
              recruitment, helping HR teams save time and focus on hiring the
              right talent. Our intelligent automation handles the heavy lifting
              while you focus on what matters most - connecting with exceptional
              candidates.
            </p>
          </div>
        </div>

        {/* Feature Section 2 */}
        <div
          style={{ ...styles.featureSection, ...styles.featureSectionReverse }}
        >
          <div style={styles.featureImageWrapper}>
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80"
              alt="Fair Hiring"
              style={styles.featureImage}
            />
          </div>
          <div style={styles.featureContent}>
            <h3 style={styles.featureTitle}>Fair and Bias-Free Hiring</h3>
            <p style={styles.featureText}>
              Our AI ensures that hiring decisions are fair and data-driven,
              reducing bias and promoting diversity and inclusion in
              recruitment. Every candidate is evaluated on merit, skills, and
              potential, creating opportunities for talent from all backgrounds.
            </p>
          </div>
        </div>
      </div>

       <style>{`
        @media (max-width: 1024px) {
          .hero-heading { font-size: 46px !important; }
          .hero-subheading { font-size: 20px !important; }
        }
        @media (max-width: 768px) {
          .hero-heading { font-size: 36px !important; text-align:center; }
          .hero-subheading { text-align:center; }
          .hero-stats { justify-content:center; gap:20px; }
          .hero-stats div { text-align:center; }
          [style*="display: flex"][style*="align-items: center"][style*="gap: 60px"] {
            flex-direction: column !important;
            text-align: center !important;
          }
        }
        @media (max-width: 480px) {
          .hero-heading { font-size: 30px !important; }
          .hero-subheading { font-size: 18px !important; }
          .hero-stats span { font-size: 14px !important; }
          [style*="padding: 40px 30px"] { padding: 24px 16px !important; }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default AboutUs;
